import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'

@vservice()
export class AdminContentCampaignUpdateManualDiscountUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentCampaignService
  ) {
  }

  isLoading = false

  isSuccess = false

  execute(contentCampaignId: number, manualDiscount: number) {
    return this.service
      .updateCampaignManualDiscount(contentCampaignId, { manual_discount: manualDiscount })
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}